import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFoundPage } from './pages/not-found/not-found.page';
import { ErrorRoutingModule } from './error-routing.module';
import { GlobalErrorHandler } from './global-error.handler';
import { SystemErrorPage } from './pages/system-error/system-error.page';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [CommonModule, ErrorRoutingModule, SharedModule],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ],
  declarations: [SystemErrorPage, NotFoundPage]
})
export class ErrorModule {}
